export class ExteriorUpdateLayout {
	public fields = [
		{ fieldName: 'exteriorUpdatedComponent', label: 'Component' },
		{ fieldName: 'exteriorUpdateType', label: 'Type' },
		{ fieldName: 'exteriorUpdateTimeframe', label: 'Timeframe' },
		{ fieldName: 'exteriorUpdateDescription', label: 'Description' }
	];
}
